import React, { useEffect, useState } from "react";

import { checkAdminAccess, useAdminUserContext, useNavigate, useParams } from "utils";

import { ErrorBoundary, MainPage, Tabs } from "components";

import { CropMixComposerCommercialMixes } from "pages/admin/programs/CropMixComposerCommercialMixes";
import { DigitalAgronomistCropPractices } from "pages/admin/programs/DigitalAgronomistCropPractices";
import { FundingList } from "pages/admin/programs/FundingList";

export const Programs = () => {
  const { section } = useParams();
  const { user } = useAdminUserContext();

  const [currentSection, setCurrentSection] = useState(false);
  const navigate = useNavigate();

  const tabList = [
    {
      name: "EU Funding",
      key: "funding",
      component: <FundingList />,
    },
    {
      name: "Digital Agronomist Crop Practices",
      key: "digital-agronomist-crop-practices",
      component: <DigitalAgronomistCropPractices />,
    },
    {
      name: "Crop Mix Composer Commercial Mixes",
      key: "crop-mix-composer-commercial-mixes",
      component: <CropMixComposerCommercialMixes />,
    },
  ];

  const getTabItems = () => {
    const tabs = [];
    tabList.forEach((tab) => {
      if (checkAdminAccess(user.role, `programs/${tab.key}`)) {
        tabs.push({
          label: tab.name,
          key: tab.key,
          children: <ErrorBoundary>{tab.component}</ErrorBoundary>,
        });
      } else {
        tabs.push({
          label: tab.name,
          key: tab.key,
          children: <ErrorBoundary>{tab.component}</ErrorBoundary>,
        });
      }
    });
    return tabs;
  };

  useEffect(() => {
    setCurrentSection(section);
  }, [section]);

  return (
    <MainPage pageName={"admin"}>
      <Tabs activeKey={currentSection} size="small" onChange={(v) => navigate({ pathname: `/programs/${v}` }, { replace: true })} items={getTabItems()} />
    </MainPage>
  );
};
